module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/info_prompt@3x.png?0.0.53";